const state = {
  headerTitle: '',
  isNavOpen: false,
  headerType: 'default',
  backLink: '',
  isLoading: false,
  isPcSearchMode: false,
  directLanding: true,
};

const mutations = {
  'SET_HEADER_TITLE' (state, title) {
    state.headerTitle = title;
  },
  'SET_HEADER_TYPE' (state, type) {
    state.headerType = type;
  },
  'SET_NAV_TOGGLE' (state, bool) {
    state.isNavOpen = bool;
  },
  'SET_BACK_LINK' (state, backLink) {
    state.backLink = backLink;
  },
  'SET_LODING_CONDITION' (state, bool) {
    state.isLoading = bool;
  },
  'SET_PC_SEARCH_MODE' (state, bool) {
    state.isPcSearchMode = bool;
  },
  'SET_DIRECT_LANDING' (state, bool) {
    state.directLanding = bool;
  },
};

const actions = {
  changeHeaderTitle: ({ commit }, title) => {
    commit('SET_HEADER_TITLE', title);
  },
  changeHeaderType: ({ commit }, type) => {
    commit('SET_HEADER_TYPE', type);
  },
  changeBackLink: ({ commit }, backLink) => {
    commit('SET_BACK_LINK', backLink);
  },
  changeLoadingCondition: ({ commit }, bool) => {
    commit('SET_LODING_CONDITION', bool);
  },
  navToggle: ({ commit, dispatch }, bool) => {
    commit('SET_NAV_TOGGLE', bool);
    if (bool) {
      dispatch("changeBgLayer", true);
    } else {
      dispatch("changeBgLayer", false);
    }
  },
  changePcSearchMode: ({ commit }, bool) => {
    commit('SET_PC_SEARCH_MODE', bool);
  },
  directLanding: ({ commit }, bool) => {
    commit('SET_DIRECT_LANDING', bool);
  },
};

const getters = {
  headerTitle: state => {
    return state.headerTitle;
  },
  headerType: state => {
    return state.headerType;
  },
  isNavOpen: state => {
    return state.isNavOpen;
  },
  backLink: state => {
    return state.backLink;
  },
  isLoading: state => {
    return state.isLoading;
  },
  isPcSearchMode: state => {
    return state.isPcSearchMode;
  },
  directLanding: state => {
    return state.directLanding;
  },
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/condition/pageInformation.js